import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js'
import Multiselect from 'vue-multiselect'
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'hub-mapping',
  components: { VueElementLoading, Multiselect },
  props: ['hubid', 'hubname'],
  data() {
    return {
      isLoading: false,
      hubLoading: '',
      addmodalShow: false,
      maphubs: false,
      checkAllHub: false,
      mappedhublist: [],
      modelArr: [],
      HubArr: [],
      allHubData: [],
      checked: [],
      destData: [],
      hubdetailsarray: [],
      DestHubNameData: [],
      hubs: [],
      currentHub: '',
      hubnameerror: ''
    }
  },
  computed: {},
  filters: {},
  mounted() {
    let userdetailEncrypt = window.localStorage.getItem('userdetail')
    let bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    let plaintext = bytes.toString(CryptoJS.enc.Utf8);
    let userdetail = JSON.parse(plaintext)
    this.useremail = userdetail[0].email;
    this.getBagDetails()
  },
  methods: {
    mapnewhubs() {
      this.maphubs = true
      this.currentHub = this.hubname + '(' + this.hubid + ')'
      this.getHubNames()
    },
    labelWithHub({ HubID, HubName }) {
      return `${HubName} - (${HubID})`;
    },
    addnewhubs() {
      if (!this.hubs || this.hubs.length <= 0) {
        this.hubnameerror = 'Please select hub'
        return false;
      }
      this.isLoading = true;
      let nArr = []
      nArr = this.hubs.map((elem) => { return { hubid: elem.HubID, hubname: elem.HubName }; });
      this.input = {
        SorterLocation: this.hubid,
        SorterLocationName: this.hubname,
        hubIdAndHubName: nArr,
        CreatedBy: this.useremail,
        IsUpdate: false,
      }
      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + "mapBagSorterDetails",
        'data': this.input,
        headers: {
          'Authorization': "authkey xB84JJ89Hd25"
        }
      })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            this.resetForm();
            this.getBagDetails();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },
    getHubNames() {
      this.hubLoading = 'Loading Hubs...'
      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
        .then(result => {
          this.hubLoading = ''
          this.hubdetailsarray = result.data.ResponseData
          this.hubnameerror = ''
        }, error => {
          console.error(error)
        })
    },
    closeStatusModal() {
      this.addmodalShow = false
    },
    closeWindow() {
      this.maphubs = false
    },
    updateMappedHubs() {
      this.isLoading = true;
      let nArr = this.allHubData.filter((elem) => this.modelArr.find((el) => elem.hubid == el));
      this.input = {
        SorterLocation: this.hubid,
        SorterLocationName: this.hubname,
        hubIdAndHubName: nArr,
        CreatedBy: this.useremail,
        IsUpdate: true,
      }
      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + "mapBagSorterDetails",
        'data': this.input,
        headers: {
          'Authorization': "authkey xB84JJ89Hd25"
        }
      })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            this.resetForm();
            this.getBagDetails();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },
    resetForm() {
      this.addmodalShow = false;
      this.maphubs = false;
      this.$validator.reset();
      this.resetDes();
      this.resetFields();
    },
    resetDes() {
      this.HubArr = [];
      this.destData = [];
      this.allHubData = [];
      this.modelArr = [];
      this.checked = [];
      this.mappedhublist = [];
      this.connDestLoading = false;
      this.checkAllHub = false;
      this.DestHubNameData = [];
    },
    resetFields() {
      this.hubs = [];
      this.currentHub = '';
      this.hubnameerror = '';
      this.hubdetailsarray = [];
    },
    getBagDetails() {
      this.input = ({
        SorterLocation: this.hubid
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'getBagSorterMappingDetails',
        'data': this.input,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      })
        .then(result => {
          if (result.data.ResultCode == 100) {
            let j = 0; let list = []; let dlist = [];
            let hData = result.data.ResponseData;
            for (const element of hData) {
              if (j < 4) {
                list.push({
                  hubId: element.HubID,
                  hubName: element.HubName
                });
              } else {
                dlist.push(list);
                list = []
                list.push({
                  hubId: element.HubID,
                  hubName: element.HubName
                });
                j = 0;
              }
              j++;
              if (element.isHubSelected == true) {
                (this.HubArr.indexOf(element.HubID) === -1) ? this.HubArr.push(element.HubID) : '';
                this.checked[element.HubID] = true;
              }
              this.destData.push({
                hubId: element.HubID,
                hubName: element.HubName
              });
              const allH = this.allHubData.some(el => el.hubid === element.HubID);
              if (!allH) {
                this.allHubData.push({
                  hubid: element.HubID,
                  hubname: element.HubName
                });
              }
            }
            this.modelArr = (this.modelArr.length > 0) ? this.modelArr : this.HubArr;
            dlist.push(list);
            this.mappedhublist = dlist;
            if (this.HubArr.length === this.destData.length) this.checkAllHub = true;
          } else {
            this.$alertify.error(result.data.ReturnMessage, "", "error");
          }
          this.isLoading = false;
        }, error => {
          this.isLoading = false
          console.error(error)
        })
    },
    updateCheckHubs(event) {
      this.checked[event.target.id] = event.target.checked;
      if (event.target.checked == false) {
        this.modelArr = this.modelArr.filter(el => el != event.target.id)
      } else {
        this.modelArr.indexOf(event.target.id) === -1 ? this.modelArr.push(parseInt(event.target.id)) : '';
      }
      this.checkAllHub = (this.destData.length === this.modelArr.length) ? true : false;
    },
    onSubmitHub: function (elem) {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.addmodalShow = true
        } else {
          return false;
        }
      }).catch(() => { });
    },
    checkHub() {
      if (typeof InstallTrigger !== 'undefined' == true) { this.checkAllHub = !this.checkAllHub; }
      this.HubArr = [];
      let nArr = [...new Set(this.destData.map(a => a.hubId))];
      if (this.checkAllHub) {
        for (const element of this.destData) {
          this.checked[element.hubId] = true;
        }
        this.HubArr = nArr;
        let arr = [...this.modelArr, ...nArr];
        this.modelArr = [...new Set(arr)];
      } else {
        for (const element of this.destData) {
          this.checked[element.hubId] = false;
        }
        this.modelArr = this.modelArr.filter(val => !nArr.includes(val));
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/components/BagSorter/HubMapping/HubMapping.js